import * as icons from "lucide-vue-next";

export function getIcon(icon, iconType) {
  if (icon) return icon;

  switch (iconType) {
    // navigation
    case "start":
      return icons.LayoutDashboard;
    case "cases":
      return icons.FolderOpen;
    case "reminders":
      return icons.Calendar;
    case "calendarDays":
      return icons.CalendarDays;
    case "calendarSettings":
      return icons.CalendarCog;
    case "addresses":
      return icons.BookUser;
    case "messages":
      return icons.Mail;
    case "inbox":
      return icons.Inbox;
    case "coreData":
      return icons.IdCard;
    case "help":
      return icons.HelpCircle;
    case "features":
      return icons.Sparkles;
    case "addins":
      return icons.Puzzle;
    case "apps":
      return icons.LayoutGrid;
    case "summary":
      return icons.FileText;
    case "settings":
      return icons.Settings;
    case "userSettings":
      return icons.UserCog;
    case "subscription":
      return icons.CreditCard;
    case "billing":
      return icons.FileText;
    case "admin":
      return icons.Shield;
    case "lifeBuoy":
      return icons.LifeBuoy;
    case "chat":
      return icons.MessageCircle;
    case "logout":
      return icons.LogOut;

    // tenant-types
    case "organization":
      return icons.Building2;
    case "companies":
      return icons.Building;
    case "locations":
      return icons.MapPinned;
    case "departments":
      return icons.Briefcase;
    case "users":
      return icons.Users;

    // organization-roles
    case "customer":
      return icons.User;
    case "car-dealer":
      return icons.Car;
    case "lawyer":
      return icons.Scale;
    case "specialist":
      return icons.ClipboardCheck;
    case "towing-service":
      return icons.Truck;
    case "insurance":
      return icons.ShieldCheck;
    case "insurance-broker":
      return icons.Handshake;
    case "fleet":
      return icons.CarFront;
    case "police":
      return icons.Siren;
    case "prosecutor":
      return icons.Gavel;
    case "bank":
      return icons.Landmark;
    case "witness":
      return icons.UserCheck;

    // utils
    case "check":
      return icons.Check;
    case "squareX":
      return icons.SquareX;
    case "cancel":
      return icons.X;
    case "square":
      return icons.Square;
    case "add":
      return icons.Plus;
    case "plus":
      return icons.Plus;
    case "link":
      return icons.Link2;
    case "eye":
      return icons.Eye;
    case "edit":
      return icons.Pencil;
    case "delete":
      return icons.Trash2;
    case "download":
      return icons.Download;
    case "undo":
      return icons.Undo2;
    case "save":
      return icons.Save;
    case "more":
      return icons.MoreVertical;
    case "left":
      return icons.ChevronLeft;
    case "right":
      return icons.ChevronRight;
    case "chevronLeft":
      return icons.ChevronLeft;
    case "chevronRight":
      return icons.ChevronRight;
    case "chevronDown":
      return icons.ChevronDown;
    case "chevronUp":
      return icons.ChevronUp;
    case "copy":
      return icons.Copy;
    case "menu":
      return icons.Menu;
    case "phone":
      return icons.Phone;
    case "input":
      return icons.FileInput;
    case "shield":
      return icons.Shield;
    case "keyRound":
      return icons.KeyRound;
    case "userPlus":
      return icons.UserPlus;
    case "send":
      return icons.Send;
    case "email":
      return icons.Mail;
    case "casePlus":
      return icons.FilePlus;
    case "userCheck":
      return icons.UserCheck;
    case "userOff":
      return icons.UserX;
    case "lockReset":
      return icons.KeyRound;
    case "clock":
      return icons.Clock;
    case "search":
      return icons.Search;
    case "company":
      return icons.Building;
    case "phoneCall":
      return icons.PhoneCall;
    case "user":
      return icons.User;
    case "address":
      return icons.MapPin;
    case "upload":
      return icons.FileUp;
    case "clip":
      return icons.Paperclip;
    case "lifeBuoy":
      return icons.LifeBuoy;
    case "filter":
      return icons.SlidersHorizontal;
    case "fileSearch":
      return icons.FileSearch;
    case "sparkles":
      return icons.Sparkles;
    case "camera":
      return icons.Camera;
    case "carFront":
      return icons.CarFront;
    case "checkCircle":
      return icons.CheckCircle;
    case "alertCircle":
      return icons.AlertCircle;
    case "info":
      return icons.Info;
    case "fileText":
      return icons.FileText;
    case "circle":
      return icons.Circle;
    case "arrowRightLeft":
      return icons.ArrowLeftRight;
    case "star":
      return icons.Star;
    case "starOff":
      return icons.StarOff;
    case "globe":
      return icons.Globe;
    case "wrench":
      return icons.Wrench;
    case "carRental":
    case "car-rental":
      return icons.CarTaxiFront;
    case "handshake":
      return icons.Handshake;
    case "contact":
      return icons.Contact;
    case "building2":
      return icons.Building2;
    case "history":
      return icons.History;
    case "qrCode":
      return icons.QrCode;
    case "smartphone":
      return icons.Smartphone;
    case "wifi":
      return icons.Wifi;
    case "loader":
      return icons.Loader2;
    default:
      return null;
  }
}

export function getPageColor(page) {
  switch (page) {
    default:
      return "var(--primary-color)";
  }
}
